import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

html {
  font-size: 10px;
}

body {
  margin: 0;
  font-family: 'Ubuntu', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.6rem;
}

h3 {
 font-weight: 500;
}

h2 {
font-size: 2.8rem;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

#usercom-launcher-dot-frame {
  display: none;
}

.tippy-tooltip {
  background-color: white!important;
  border-radius: 8px!important;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.15);

.arrow-regular, .arrow-big {
  border-top-color: white!important;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.15);
  } 
}

  .tippy-tooltip.dark-theme {
    background-color: #2A3030!important;
    border-radius: 6px!important;
    color: white;
    font-size: 12px;
    padding: 10px 15px;
    
    .arrow-regular, .arrow-big, .arrow-small {
      border-top-color: #2A3030!important;
    } 
  }
  
  .tippy-popper[x-placement^=right] [x-arrow].arrow-small {
    border-right: 5px solid #2A3030!important;
    border-top: 5px solid transparent!important;
    border-bottom: 5px solid transparent!important;
    left: -5px;
}

.gradebook-comment-tooltip {
  text-align: left;
  word-break: break-word;
  color: black;
  line-height: 18px;
}

::-webkit-scrollbar {
  width: 1rem;
  height: 1rem;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #7c7c7d; 
}
 
::-webkit-scrollbar-thumb {
  background: #7c7c7d; 
}

::-webkit-scrollbar-thumb:hover {
  background: #f3be4d; 
}

  .alert-modal-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 20;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0,0, 0.7);
  }
  
  .alert-modal-content {
    position: static;
    background-color: #dadada;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.75);
    width: 400px;
    min-height: 150px;
    box-sizing: border-box;
    border: none;
    border-radius: 0;
    outline: none;
  }
`;
